import type {
  DraftGroup,
  TimelineEntry,
  TimelineEvent,
} from '../types/historyEvent';

/**
 * Groups consecutive DRAFT_SAVED events into `DraftGroup` objects.
 * Single drafts (not adjacent to another draft) pass through unchanged.
 *
 * @param events - Flat timeline events, newest-first.
 * @returns Timeline entries with consecutive drafts collapsed.
 */
export function groupTimelineEvents(events: TimelineEvent[]): TimelineEntry[] {
  if (!events.length) return [];

  const entries: TimelineEntry[] = [];
  let draftAcc: TimelineEvent[] = [];

  function flushDrafts() {
    if (draftAcc.length === 0) return;

    if (draftAcc.length === 1) {
      entries.push(draftAcc[0]);
    } else {
      const group: DraftGroup = {
        type: 'draft-group',
        id: `draft-group-${draftAcc[0].id}`,
        latestEvent: draftAcc[0],
        events: draftAcc,
      };
      entries.push(group);
    }

    draftAcc = [];
  }

  events.forEach((event) => {
    if (event.kind === 'DRAFT_SAVED') {
      draftAcc.push(event);
    } else {
      flushDrafts();
      entries.push(event);
    }
  });

  flushDrafts();

  return entries;
}
